export default {
	ADD_TILE: 'Add tile'
};
